import Head from "next/head"
import { NextSeo } from "next-seo"
import data from '../components/data'
const About = () => {
    return (
        <>
            <NextSeo
                title="Nemokama Python pamoka | Pirmas kodas"
                description="Pirmas kodas siūlo sudalyvauti nemokamoje pamokoje"
            />
            <article className="prose dark:prose-invert">
                <h1>Nemokama Python pamoka</h1>
                <p>
                    Kiekvieną pirmadienį, 17:00 val. vedame nemokamas programavimo su Python pamokas.
                </p>
                <p>Viso siūlome 4 nemokamų pamokų tipus</p>
                <ul>
                    <li>Įvadas į Python</li>
                    <li>Duomenų analizė su Python (Pandas)</li>
                    <li>Mašininis mokymasis su Python (sklearn, lightgbm, tensorflow, pytorch) </li>
                    <li>Tinklalapių kūrimas (Web API, backend, FastAPI, Django, Flask)</li>
                </ul>
                <p>Sudomino? Kviečiu užpildyti formą. Gavę Jūsų atsakymus atsiūsime pakvietimą į pamoką Jus dominančia tema!</p>
                <div className="flex justify-end">
                    <a
                        className={`rounded-md bg-mustard p-3 text-lg font-bold dark:bg-green-500 dark:text-black`}
                        href={data.links.freePythonLectureRegistration}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        Registruotis
                    </a>
                </div>
            </article>
        </>
    )
}

export default About
